import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

/** Single platform admin (sidebar + /admin + admin edge functions). */
export const PLATFORM_SUPERADMIN_EMAIL = "info@richter-visuals.com";

export function isPlatformSuperadminEmail(email: string | null | undefined): boolean {
  return !!email && email.toLowerCase() === PLATFORM_SUPERADMIN_EMAIL.toLowerCase();
}

export async function checkIsPlatformAdmin(client: SupabaseClient<Database>): Promise<boolean> {
  const {
    data: { user },
    error,
  } = await client.auth.getUser();
  if (error || !user) return false;
  return isPlatformSuperadminEmail(user.email);
}
